import { configureStore } from '@reduxjs/toolkit';
import CustomizerReducer from './customizer/CustomizerSlice';
import TicketReducer, { rilasciaTaskNonInCarico } from './app/ticket/TicketSlice';
import AddNavTaskReducer from './app/addNavTask/AddNavTaskSlice';
import EmailReducer from './apps/email/EmailSlice';
import EventsReducer from './app/agenda/EventSlice';
import AllegatiReducer from './app/allegati/AllegatiSlice';
import TabDiarioNoteReducer from './app/diarioTrattazione/NoteSlice';
import WsReducer from './app/ws/WsSlice';
import TipologieForm from './app/formTipoligie/TicketFormTipologie';
import RiserveAuthorityReducer from './app/riserveAuthority/RiserveAuthoritySlice';
import CheckListReducer from './app/CheckListEsiti/CheckListSlice';
import FinancialsReducer from './app/financialsTab/FinancialsSlice';
import RicercaSinistriReducer from './app/ricercaSinistro/RicercaSinistriSlice';
import MultiValutaSliceReducer from './app/multiValuta/MultiValutaSlice';
import PkceSliceReducer from './app/pkce/PkceSlice';
import EventiCatastrofaliReducer from './app/EventiCatastrofali/EventiCatastrofaliSlice';
import PitecoReducer from './app/piteco/PitecoSlice';
import DocumentiAccessoReducer from './app/documentiAccesso/DocumentiAccessoSlice';
import LuogoEventoReducer from './app/luogoEvento/LuogoEventoSlice';
import { registraGestoreTaskNonInCarico } from '../data/axiosInstance/axiosInstance';

export const store = configureStore({
  reducer: {
    customizer: CustomizerReducer,
    ticketReducer: TicketReducer,
    addNavTaskReducer: AddNavTaskReducer,
    emailReducer: EmailReducer,
    eventsReducer: EventsReducer,
    allegatiReducer: AllegatiReducer,
    tabDiarioNoteReducer: TabDiarioNoteReducer,
    wsReducer : WsReducer,
    tipologieFormReducer: TipologieForm,
    riserveAuthorityReducer:RiserveAuthorityReducer,
    checkListReducer:CheckListReducer,
    financialsReducer: FinancialsReducer,
    ricercaSinistriReducer: RicercaSinistriReducer,
    multiValutaSliceReducer: MultiValutaSliceReducer,
    pkceReducer: PkceSliceReducer,
    eventiCatastrofali: EventiCatastrofaliReducer,
    pitecoReducer: PitecoReducer,
    documentiAccessoReducer: DocumentiAccessoReducer,
    luogoEventoReducer: LuogoEventoReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    }),
});

// 403 TASK_NON_IN_CARICO su una scrittura: il task aperto esce dai task in carico [CSP-3808].
registraGestoreTaskNonInCarico(() => store.dispatch(rilasciaTaskNonInCarico()));

export default store;
